export const extractDownloadPath = (url: string): string => {
  const dashboardIndex = url.indexOf('/dashboard');
  return dashboardIndex !== -1 ? url.substring(dashboardIndex) : '';
}; 